<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <!-- <div class="pl-5 pr-5">
            <recommendation-items
              v-if="selectedProcess"
              rightPanelId="sidebar-process-recommendation"
              level="datasource"
              organizationScopedState="organizationProcessDatasource"
              libraryScopedState="datasource"
              @interceptForSetParent="interceptForSetParent"
              :id="selectedProcess._id"
            />
          </div> -->

          <LibraryItems
            rightPanelId="sidebar-new-datasource"
            organizationScopedState="organizationProcessDatasource"
            libraryScopedState="datasource"
            @interceptForSetParent="interceptForSetParent"
            :hideCategoryFilter="true"
          />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("datasource.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('datasource.name')"
            :label="$t('datasource.name')"
          />

          <h6 class="mt-4">{{ $t("process.text") }}</h6>
          <filter-select
            id="processFilter"
            ref="processFilter"
            :placeholder="$t('process.text')"
            :multiple="false"
            @filter="onSearch"
            :selected="form.process"
            @changed="onSelect"
          />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>

      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("datasource.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('datasource.name')"
          :label="$t('datasource.name')"
        />

        <h6 class="mt-4">{{ $t("process.text") }}</h6>

        <filter-select
          id="processFilter1"
          ref="processFilter1"
          :placeholder="$t('process.text')"
          :multiple="false"
          @filter="onSearch"
          :selected="form.process"
          @changed="onSelect"
        />

        <div v-if="form && form._id" class="mt-4">
          <b-form-checkbox v-model="changeInAllHierarchy" name="check-button" switch class="switch d-inline"></b-form-checkbox>
          <label class="switch">{{ $t("common.change-in-all-hierarchy") }}</label>
        </div>

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import RecommendationItems from "@cc/recommendation-items";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
    RecommendationItems,
  },
  data() {
    return {
      form: { name: undefined },
      changeInAllHierarchy: false,
      formError: undefined,
      entityName: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...v, ...this.prepareFormForEdit(v), _id: v._id };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      immediate: true,

      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...v, ...this.prepareFormForEdit(v), _id: v._id };
        this.entityName = this.form.name;
      },
    },
    selectedProcess: {
      deep: true,
      immediate: true,
      handler(v) {
        this.onSelect(v);
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationProcessDatasource/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationProcessDatasource/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationProcessDatasource/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationProcessDatasource/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationProcessDatasource/isCoping"];
    },
    selectedProcess() {
      return this.$store.getters["organizationDepartmentProcess/selectedEntity"];
    },
  },
  mounted() {},
  methods: {
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("organizationProcessDatasource/save", { payload: this.form, changeInAllHierarchy: this.changeInAllHierarchy });
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.commit("organizationDatasource/editedEntity");
      this.$store.commit("organizationDatasource/copingEntity");
      // this.$store.dispatch("organizationDatasource/resetForm");
    },
    async onSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartmentProcess/paginateForSearch`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onSelect(item) {
      this.form = { ...this.form, process: item };
    },

    interceptForSetParent(payload) {
      payload.process = this.selectedProcess;
    },
  },
};
</script>
